import { Link } from "react-router-dom";
import Slider from "react-slick";
const Topshopslider = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 787,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  const topShops = [
    {
      image: "../../assets/images/topshops/img5.png",
      title: "Cyber Punk",
      balance: "213.21",
      link: "/projectpage",
    },
    {
      image: "../../assets/images/topshops/img2.png",
      title: "Cyber Punk",
      balance: "213.21",
    },
    {
      image: "../../assets/images/topshops/img3.png",
      title: "Cyber Punk",
      balance: "213.21",
    },
    {
      image: "../../assets/images/topshops/img4.png",
      title: "Cyber Punk",
      balance: "213.21",
    },
    {
      image: "../../assets/images/topshops/img1.png",
      title: "Cyber Punk",
      balance: "213.21",
    },
    {
      image: "../../assets/images/topshops/img6.png",
      title: "Cyber Punk",
      balance: "213.21",
    },
    {
      image: "../../assets/images/topshops/img7.png",
      title: "Cyber Punk",
      balance: "213.21",
    },
  ];

  const topShopsS = [
    {
      image: "../../assets/images/topshops/img2.png",
      title: "Tech Robot    ",
      balance: "213.21",
      linkto: "/projectpage",
    },
    {
      image: "../../assets/images/topshops/img6.png",
      title: "Cyber Punk",
      balance: "213.21",
      linkto: "#",
    },
    {
      image: "../../assets/images/topshops/img7.png",
      title: "Cyber Punk",
      balance: "213.21",
      linkto: "#",
    },
    {
      image: "../../assets/images/topshops/img4.png",
      title: "Cyber Punk",
      balance: "213.21",
      linkto: "#",
    },
    {
      image: "../../assets/images/topshops/img5.png",
      title: "Cyber Punk",
      balance: "213.21",
      linkto: "#",
    },
    {
      image: "../../assets/images/topshops/img3.png",
      title: "Cyber Punk",
      balance: "213.21",
      linkto: "#",
    },
    {
      image: "../../assets/images/topshops/img4.png",
      title: "Cyber Punk",
      balance: "213.21",
      linkto: "#",
    },
  ];
  return (
    <Slider {...settings}>
      {topShopsS.map((item, index) => {
        return (
          <div key={index}>
            <Link to={item.linkto} style={{ color: "transparent" }}>
              <div className="top-shop-single-wrap">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="for-verified">
                    <img className="item-img" src={item.image} />
                    <div className="ver-icon-wrap">
                      <img
                        className="verified-img shop"
                        src="../../../assets/images/topshops/verified-icon.png"
                      />
                    </div>
                  </div>
                  <h3 className="topshop-tit">{item.title}</h3>
                  <div className="d-flex align-items-center balance-wrap">
                    <img
                      src="../../assets/images/topshops/icon-eth.png"
                      alt=""
                    />
                    <h6 className="eth-balance">{item.balance}</h6>
                  </div>
                </div>
              </div>
            </Link>
            <div className="top-shop-single-wrap">
              <div className="d-flex align-items-center justify-content-between">
                <div className="for-verified">
                  <img className="item-img" src={item.image} />
                  <div className="ver-icon-wrap">
                    <img
                      className="verified-img shop"
                      src="../../../assets/images/topshops/verified-icon.png"
                    />
                  </div>
                </div>
                <h3 className="topshop-tit">{item.title}</h3>
                <div className="d-flex align-items-center balance-wrap">
                  <img src="../../assets/images/topshops/icon-eth.png" alt="" />
                  <h6 className="eth-balance">{item.balance}</h6>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  );
};
export default Topshopslider;
